export default {
  //在线答疑
  chatStuList: '',
  chatDetail: '',
  chatReplayStu: '',
  chatDel: '',
  chatEdit: '',
}



// WEBPACK FOOTER //
// ./src/store/chat/states.js